import { render } from "./employees-header.vue?vue&type=template&id=5535a9bf&scoped=true"
import script from "./employees-header.vue?vue&type=script&lang=js"
export * from "./employees-header.vue?vue&type=script&lang=js"

import "./employees-header.vue?vue&type=style&index=0&id=5535a9bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5535a9bf"]])

export default __exports__